export const ChatStorageService = {
    savePendingChat(chatData:any) {
        const pendingChat = {
            id: chatData.id,
            question: chatData.question,
            file_ids: chatData.file_ids,
            fileLinks: chatData.fileLinks,
            timestamp: Date.now(),
            url: window.location.pathname
        };
        localStorage.setItem('pendingChat', JSON.stringify(pendingChat));
    },

    getPendingChat() {
        const pendingChat = localStorage.getItem('pendingChat');
        if (pendingChat) {
            return JSON.parse(pendingChat);
        }
        return null;
    },

    clearPendingChat() {
        localStorage.removeItem('pendingChat');
    }
};